import consts from '../main/consts';

const navigationConfig = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: 'dashboard',
    url: `${consts.CONTEXT}/dashboard`,
    color: '#757575',
    status: [],
  },
  {
    id: 'estimated',
    title: 'Pedidos Previstos',
    icon: 'estimated',
    url: `${consts.CONTEXT}/estimated`,
    color: '#091582',
    status: ['PREVISTO'],
    enabledByDefault: false,
  },
  {
    id: 'new-orders',
    title: 'Novos Pedidos',
    icon: 'new-orders',
    url: `${consts.CONTEXT}/new-orders`,
    color: '#12CD0B',
    status: consts.EDIT_IMMEDIATELY ? ['NOVO_PEDIDO'] : ['NOVO_PEDIDO', 'EDITADO'],
  },
  {
    id: 'picking',
    title: 'Em Separação',
    icon: 'picking',
    url: `${consts.CONTEXT}/picking`,
    color: '#00CBFF',
    status: consts.EDIT_IMMEDIATELY ? ['EM_SEPARACAO', 'EDITADO'] : ['EM_SEPARACAO', 'EM_EDICAO'],
  },
  {
    id: 'ready-to-go',
    title: 'Pronto para Retirada',
    icon: 'ready-to-go',
    url: `${consts.CONTEXT}/ready-to-go`,
    color: '#FFAA00',
    status: ['PRONTO_PARA_SAIR'],
  },
  {
    id: 'shipping',
    title: 'Saiu Para Entrega',
    icon: 'shipping',
    url: `${consts.CONTEXT}/shipping`,
    color: '#CE00FF',
    status: ['SAIU_PARA_ENTREGA'],
  },
  {
    id: 'returning-to-storage',
    title: 'Retornar Para Estoque',
    icon: 'returning-to-storage',
    url: `${consts.CONTEXT}/returning-to-storage`,
    color: '#B72F2C',
    status: ['RETORNAR_PARA_ESTOQUE'],
  },
  {
    id: 'history',
    title: 'Histórico',
    icon: 'history',
    url: `${consts.CONTEXT}/history`,
    color: '#757575',
    status: ['FINALIZADO', 'CANCELADO', 'DEVOLVIDO'],
  },
];

export default navigationConfig;
